import { useMemo } from "react";

import axios from "axios";
import useSWR from "swr";

import { HOST_API } from "../config-global";

const baseUrl = `/api/system/`;

export function useGetVersion() {
  const url = `${HOST_API}${baseUrl}version`;

  const fetcher = url => axios.get(url).then(res => res.data);

  const { data, isLoading, error, isValidating, mutate } = useSWR(url, fetcher);

  const memoizedValue = useMemo(
    () => ({
      version: data || "",
      isLoading,
      error,
      isValidating,
      mutate,
    }),
    [data, error, isLoading, isValidating, mutate]
  );

  return memoizedValue;
}

export const termsAndConditionsEndpoint = `${HOST_API}${baseUrl}terms-and-conditions`;
